import React, { useEffect, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

import Breadcrumbs from '../Breadcrumbs';
import { Details } from './Details';
import { DetailsModal } from './DetailsModal';
import { Filter } from './Filter';
import { useStyles } from './styles';
import { Table } from './Table';

export const AffiliateCommissions = () => {
  const classes = useStyles();

  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [isLoadingAccount] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [requestAffiliateCommissionsDetails] = useCallbackObservable(
    (affiliateId) => affiliateCommissionsService.requestAffiliateCommissionsDetails(affiliateId),
    []
  );

  useEffect(() => {
    return () => affiliateCommissionsService.cleanFilter();
  }, []);

  if (isLoadingAccount || !user) return null;

  const handleSeeDetailsClick = (partnerId: number) => {
    requestAffiliateCommissionsDetails(partnerId);
    setIsDetailsModalOpen(true);
  };

  const closeDetailsModal = () => setIsDetailsModalOpen(false);

  const breadcrumbsLink = [
    {
      url: '/producer/reports/sales',
      name: 'Relatórios',
    },
  ];

  return (
    <>
      <Breadcrumbs navList={breadcrumbsLink} currentPage='Comissões Pagas a Afiliados' />

      <h1 className={classes.title}>Comissões Pagas a Afiliados</h1>

      <Filter />
      <Details />
      <DetailsModal handleClose={closeDetailsModal} isOpen={isDetailsModalOpen} />
      <Table handleSeeDetailsClick={handleSeeDetailsClick} />
    </>
  );
};
